import React from "react";
import { AlertTriangle, Info, Trophy } from "lucide-react";
import Modal from "../../../components/Modal";
import type { RelatorioTemposInsight } from "../../../services/controleProducaoService";

function insightClass(tom: RelatorioTemposInsight["tom"]): string {
  if (tom === "good") return "border-emerald-200 bg-emerald-50";
  if (tom === "watch") return "border-amber-200 bg-amber-50";
  return "border-sky-200 bg-sky-50";
}

function InsightIcon({ tom }: { tom: RelatorioTemposInsight["tom"] }) {
  if (tom === "good") {
    return <Trophy className="h-4 w-4 text-emerald-700" />;
  }
  if (tom === "watch") {
    return <AlertTriangle className="h-4 w-4 text-amber-800" />;
  }
  return <Info className="h-4 w-4 text-sky-700" />;
}

type InsightsModalProps = {
  isOpen: boolean;
  onClose: () => void;
  insights: RelatorioTemposInsight[];
};

const InsightsModal: React.FC<InsightsModalProps> = ({
  isOpen,
  onClose,
  insights,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Insights"
      description="Destaques de desempenho, ritmos e pontos de atenção do período."
      panelClassName="max-w-4xl"
      bodyClassName="min-h-0 flex-1 overflow-y-auto overscroll-contain p-4 sm:p-6"
    >
      <div className="grid gap-3 md:grid-cols-2">
        {insights.map((ins) => (
          <article
            key={ins.id}
            className={`rounded-lg border p-4 ${insightClass(ins.tom)}`}
          >
            <p className="flex items-center gap-2 text-sm font-semibold text-neutral-900">
              <InsightIcon tom={ins.tom} />
              {ins.titulo}
            </p>
            <p className="mt-1.5 text-sm leading-relaxed text-neutral-700">
              {ins.texto}
            </p>
          </article>
        ))}
      </div>
    </Modal>
  );
};

export default InsightsModal;
